"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var GrowView_1 = require("../GrowView");
var helpers_1 = require("../../helpers");
var ToolbarSlot = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    align-self: stretch;\n    flex-direction: column;\n    flex-shrink: 0;\n    min-width: 0;\n    min-height: 0;\n"], ["\n    display: flex;\n    align-self: stretch;\n    flex-direction: column;\n    flex-shrink: 0;\n    min-width: 0;\n    min-height: 0;\n"])));
var GridSlot = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    align-self: stretch;\n    flex: 1;\n    flex-direction: column;\n    flex-shrink: 0;\n    min-width: 0;\n    min-height: 0;\n"], ["\n    display: flex;\n    align-self: stretch;\n    flex: 1;\n    flex-direction: column;\n    flex-shrink: 0;\n    min-width: 0;\n    min-height: 0;\n"])));
var FragmentSlot = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    position: absolute;\n    top: -9999px;\n    left: -9999px;\n    visibility: hidden;\n"], ["\n    position: absolute;\n    top: -9999px;\n    left: -9999px;\n    visibility: hidden;\n"])));
exports.GridBodyLayout = helpers_1.createUIElement('GridBodyLayout', function (_a, ref) {
    var className = _a.className, toolbar = _a.toolbar, fragment = _a.fragment, grid = _a.grid, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, onKeyPress = _a.onKeyPress, style = _a.style, rest = __rest(_a, ["className", "toolbar", "fragment", "grid", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    return (react_1.default.createElement(GrowView_1.GrowView, __assign({}, rest, { "data-selector-id": rest['data-selector-id'] || 'grid-body-layout', className: "vm-GridBodyLayout " + className, "data-grid-body-layout": 'true', onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: ref, style: style }),
        toolbar && react_1.default.createElement(ToolbarSlot, null, toolbar),
        react_1.default.createElement(GridSlot, null, grid),
        !!fragment && react_1.default.createElement(FragmentSlot, null, fragment)));
});
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=GridBodyLayout.js.map